import { companyUserList, CompanyList } from '@/api/staffApi.js'
const state = {
  companyList: []
}
const mutations = {
  SET_COMPANYLIST: (state, companyList) => {
    state.companyList = companyList
  }
}
const actions = {
  getCompanyList ({ commit }) {
    return new Promise((reslove, reject) => {
      companyUserList().then(res => {
        if (res.data.length > 0) {
          if (res.code == 0) {
            commit('SET_COMPANYLIST', res.data)
            reslove()
          }
        } else {
          CompanyList({}).then(res => {
            if (res.code == 0) {
              commit('SET_COMPANYLIST', res.data)
              reslove()
            }
          })
        }
      }).catch(err => {
        reject(err)
      })
    })
  }
}

export default {
  // namespaced: true, // 命名作用域
  state,
  mutations,
  actions

}
